import React, { useState } from 'react';
import { Layout, Tabs, message } from 'antd';
import WorkflowUploader from '../components/WorkflowUploader';
import WorkflowList from '../components/WorkflowList';
import WorkflowQuickSearch from '../components/WorkflowQuickSearch';
import AppHeader from '../components/AppHeader';

const { Content } = Layout;

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('2');
  
  // 上传成功后切换到工作流列表
  const handleUploadSuccess = () => {
    message.success('工作流上传成功，可以在列表中查看');
    setActiveTab('2');
  };
  
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />
      <Content style={{ padding: '24px 50px' }}>
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          type="card"
          items={[
            {
              key: '1',
              label: '上传工作流',
              children: (
                <div style={{ padding: '20px 0' }}>
                  <WorkflowUploader onUploadSuccess={handleUploadSuccess} />
                </div>
              )
            },
            {
              key: '2',
              label: '工作流列表',
              children: (
                <div style={{ padding: '20px 0' }}>
                  <WorkflowList />
                </div>
              )
            },
            {
              key: '3',
              label: '快速搜索',
              children: (
                <div style={{ padding: '20px 0' }}>
                  <WorkflowQuickSearch />
                </div>
              )
            }
          ]}
        />
      </Content>
    </Layout>
  );
};

export default HomePage; 